import React, { useCallback, useEffect, useState } from 'react';
import { SupportButtonContainer } from './SupportButton.style';
import intercomLogo from '../../images/intercom-min.png';
import { useSelector } from 'react-redux';
import { supportButtonSelector } from '../../redux/supportButton/selector';
import { isPlatform } from '@ionic/react';
import useIntercomPlugin from 'src/shared/hooks/useIntercomPlugin';

const SupportButton: React.FC = () => {
  const [isActiveMessenger, setIsActiveMessenger] = useState(false);

  const { isSupportButtonActive, paddingBottomInPX, paddingRightInPX } = useSelector(supportButtonSelector);
  const { showMessenger, hideMessenger, setBottomPadding } = useIntercomPlugin();

  const onClickHandler = useCallback(async () => {
    if (isPlatform('desktop') && !isPlatform('hybrid') && !isPlatform('mobileweb') && isActiveMessenger)
      hideMessenger();
    else showMessenger();

    setIsActiveMessenger(!isActiveMessenger);
    setBottomPadding(paddingBottomInPX + 65);
  }, [isActiveMessenger, showMessenger, hideMessenger]);

  useEffect(() => {
    setBottomPadding(paddingBottomInPX);
  }, [paddingBottomInPX]);

  return isSupportButtonActive ? (
    <SupportButtonContainer
      className={'support-button'}
      paddingRightInPX={paddingRightInPX}
      paddingBottomInPX={paddingBottomInPX}
      onClick={onClickHandler}
    >
      <img src={intercomLogo} alt="intercome logo" />
    </SupportButtonContainer>
  ) : null;
};

export default SupportButton;
